// src/pages/About.js
import './About.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBookOpen,
  faBrush,
  faComments,
  faMapMarkerAlt,
  faPhoneAlt,
  faEnvelope,
  faShieldAlt,
  faHeart,
  faCheckCircle
} from '@fortawesome/free-solid-svg-icons';

const teamMembers = [
  {
    name: 'Shreekanth C',
    role: 'Vice President - Marketing',
    image: '/assets/Sreekanth.jpeg',
    description: 'Known for his creativity and proactive approach to adopting and integrating new technologies.',
  },
  {
    name: 'Nikhil Setty',
    role: 'Vice President - Sales',
    image: '/assets/Nikhil.jpeg',
    description: 'Handles customers smoothly and efficiently. His standout ability is in introducing and integrating new clients into the system seamlessly.',
  },
  {
    name: 'Kumar Swamy',
    role: 'Operational Head',
    image: '/assets/Kumarswamy.jpeg',
    description: 'Strong team player and mature team leader, known for successfully delivering all book-related tasks within SLA timelines.',
  },
];


export default function About() {
  return (
    <div className="about-container full-width">

      {/* Hero Intro */}
      <section className="about-intro">
        <h1>About WePrint PhotoBooks</h1>
        <p>
          At WePrint PhotoBooks, we don’t just print — we preserve memories. Born from a love of photography and storytelling, we create premium photobooks that bring your moments to life.
        </p>
        <p>
          From birthdays to weddings, travels to baby’s first steps — we help turn your pictures into timeless, tactile treasures.
        </p>
      </section>

      {/* CEO & Team */}
      <section className="team-section">
        <section className="ceo-section">
          <div className="ceo-content">
            <div className="ceo-text">
            <h2 className="section-title">Meet the Founder & CEO</h2>
              <h3>Prashanth Kengal</h3>
              <p>
                Driven by a strong work ethic and a passion for company development, Prashanth leads
                with a friendly and approachable style that motivates both the organization and his team.
              </p>
            </div>
            <div className="ceo-image">
              <img src="/assets/Prashanth Kengal.jpeg" alt="Prashanth Kengal" />
            </div>
          </div>
        </section>
        <h2 style={{ marginLeft: '100px' }}>Our Team</h2>
        <div className="team-grid">
          {teamMembers.map((member, i) => (
            <div className="member" key={i}>
              <img src={member.image} alt={member.name} />
              <h4>{member.name}</h4>
              <h4 className="role">{member.role}</h4>
              <p>{member.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Services */}
      <section className="services-section">
        <h2>What We Do</h2>
        <div className="services-grid">
          <div className="service">
            <FontAwesomeIcon icon={faBookOpen} className="icon" />
            <h4>Custom PhotoBooks</h4>
            <p>Personalized books with elegant layouts and premium prints.</p>
          </div>
          <div className="service">
            <FontAwesomeIcon icon={faBrush} className="icon" />
            <h4>Photoshop Services</h4>
            <p>Remove blemishes, fix colors, retouch photos — professionally.</p>
          </div>
          <div className="service">
            <FontAwesomeIcon icon={faComments} className="icon" />
            <h4>Creative Consulting</h4>
            <p>Our team helps you select designs, messages, and perfect finishes.</p>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="how-it-works">
        <h2>How It Works</h2>
        <div className="steps-wrapper">
          <div className="step-card">
            <div className="step-icon"><FontAwesomeIcon icon={faCheckCircle} /></div>
            <h4>Step 1</h4>
            <p>Contact or Visit Us with your photos</p>
          </div>
          <div className="step-card">
            <div className="step-icon"><FontAwesomeIcon icon={faCheckCircle} /></div>
            <h4>Step 2</h4>
            <p>Pick a Style, Theme, and Layout</p>
          </div>
          <div className="step-card">
            <div className="step-icon"><FontAwesomeIcon icon={faCheckCircle} /></div>
            <h4>Step 3</h4>
            <p>Preview and Approve</p>
          </div>
          <div className="step-card">
            <div className="step-icon"><FontAwesomeIcon icon={faCheckCircle} /></div>
            <h4>Step 4</h4>
            <p>Get Your Book Delivered or Picked Up</p>
          </div>
        </div>
      </section>

      {/* Client Highlights */}
      <section className="clients-section">
        <h2>Trusted by Thousands</h2>
        <p>We've printed over <strong>10,000 photobooks</strong> for families, artists, travelers, and professionals across India.</p>
        <p>Our happy customers become lifelong storytellers.</p>
      </section>

      {/* Testimonials Teaser */}
      <section className="testimonials-preview">
        <h2>Words from Our Clients</h2>
        <blockquote>“Absolutely loved my wedding book. Beautiful quality and superb service. Thank you!”</blockquote>
        <cite>— Priya Sharma, Bangalore</cite>
      </section>

      {/* Trust & Security */}
      <section className="trust-section">
        <h2>Secure. Reliable. Personal.</h2>
        <p><FontAwesomeIcon icon={faShieldAlt} /> Your photos are encrypted and handled with strict privacy and care.</p>
        <p><FontAwesomeIcon icon={faHeart} /> Every order is handmade, reviewed, and approved by our quality team.</p>
      </section>
        {/* Company Story */}
       <section className="story-section">
          <h2>Our Journey</h2>
          <p>
            Founded in Bengaluru, our small team of designers, editors, and print experts had one goal: to provide a custom photobook experience with a personal touch. Over the years, we’ve grown with our customers — constantly evolving, but always putting memories first.
          </p>
          <p>
            We understand how precious your photos are, and we treat every order like it’s our own family album.
          </p>
        </section>     

      {/* Location */}
      <section className="location-section">
        <h2>Visit Our Studio</h2>
        <p><FontAwesomeIcon icon={faMapMarkerAlt} /> #37, Sannidhi Rd, NR Colony, Basavanagudi, Bengaluru, Karnataka 560004</p>
        <p><FontAwesomeIcon icon={faPhoneAlt} /> <a href="tel:+918861494444">+91 88614 94444</a></p>
        <p><FontAwesomeIcon icon={faEnvelope} /> <a href="mailto:info@weprintphotobooks.com">info@weprintphotobooks.com</a></p>

        <iframe
          title="WePrint PhotoBooks Directions"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3890.0925608139364!2d77.5697979!3d12.9397701!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae1545de14a951%3A0x5f9c01dd10f3259!2sWePrint%20PhotoBooks%2C%20%2337%2C%20Sannidhi%20Rd%2C%20NR%20Colony%2C%20Basavanagudi%2C%20Bengaluru%2C%20Karnataka%20560004%2C%20India!5e0!3m2!1sen!2sin!4v1721313540144!5m2!1sen!2sin"
          width="100%"
          height="350"
          style={{ border: 0, borderRadius: '12px' }}
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </section>

      {/* Final CTA */}
      <section className="about-cta">
        <h2>Let’s Bring Your Photos to Life</h2>
        <p>Contact us today to begin your photobook journey — with love, design, and care.</p>
        <a href="/contact#contact-form" className="primary-btn">Get Started</a>
      </section>
    </div>
  );
}
